import React from 'react'
import { FormattedMessage } from 'react-intl'

export function intlIdToString(intlLabelID) {
  return <FormattedMessage id={intlLabelID}>{txt => txt}</FormattedMessage>
}
